// Simple utility to store and retrieve font preferences based on Auth0 user ID

export const getUserFontSize = (userId: string): number => {
  if (!userId) return 0

  try {
    const stored = localStorage.getItem(`fontSize_${userId}`)
    return stored ? parseInt(stored, 10) : 0
  } catch {
    return 0
  }
}

export const setUserFontSize = (userId: string, fontSize: number): void => {
  if (!userId) return

  try {
    localStorage.setItem(`fontSize_${userId}`, fontSize.toString())
  } catch (error) {
    console.error('Failed to save font size preference:', error)
  }
}
